// @flow
import React, { Component } from 'react';
import { PartnersHeaderBlock } from './PartnersStyles';
import NavTabs from '../../components/NavTabs';
import { TabNavLink, SpacerTab } from '../../components/TabStyles';
import { Route } from 'react-router-dom';
import { PageHeaderDiv, PageHeaderP } from '../../components/PageHeaderStyles';

type Props = {};

export default class HeaderBlock extends Component<Props> {
  handleReferred = () => (
    <PageHeaderDiv>
      <PageHeaderP>
        Below is a summary of all your referred partners and how much their
        merchants have processed so far. To view your commission earned for each
        partner, click on the row to open up a more detailed view.{' '}
      </PageHeaderP>
    </PageHeaderDiv>
  );
  render() {
    return (
      <PartnersHeaderBlock>
        <NavTabs>
          <TabNavLink to="/partners/referred">Partners</TabNavLink>
          {/* <TabNavLink exact to="/partners/refer-a-partner">
            Refer a Partner
          </TabNavLink> */}
          <SpacerTab tablet />
        </NavTabs>
        <Route path="/partners/referred" render={() => this.handleReferred()} />
      </PartnersHeaderBlock>
    );
  }
}
